import React from "react";
import type { CommandViewResponse } from "../../lib/floorStackApi.js";

interface Props {
  data: CommandViewResponse;
  visible: boolean;
}

// 5th overlay — small badge in top-right showing unread notification count.
// Live data wires through Phase F (WebSocket / SSE). For now we surface
// the snapshot-derived warning + critical incident counts.
export default function NotificationLayer({ data, visible }: Props): React.ReactElement | null {
  if (!visible) return null;
  const snap = data.latest_snapshot;
  if (!snap) return null;
  const total = snap.incident_warning_count + snap.incident_critical_count;
  if (total === 0) return null;
  const colour = snap.incident_critical_count > 0 ? "#ff5b6d" : "#ffb800";
  return (
    <g data-layer="notification" pointerEvents="none">
      <g transform="translate(960, 36)">
        <rect x={-44} y={-18} rx={10} ry={10} width={88} height={36} fill="rgba(0,0,0,0.55)" stroke={colour} strokeWidth={1} />
        <text x={-30} y={5} fontSize={13} fill={colour} fontWeight={700}>⚠</text>
        <text x={-12} y={5} fontSize={13} fill="rgba(255,255,255,0.92)" fontWeight={600}>{total}</text>
        <text x={6} y={5} fontSize={9} fill="rgba(255,255,255,0.6)">未結事件</text>
      </g>
    </g>
  );
}
